import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'filter-text',
  templateUrl: './filter-text.component.html',
  styleUrls: ['./filter-text.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterTextComponent),
      multi: true
    }
  ]
})
export class FilterTextComponent implements ControlValueAccessor {
  public value: string;
  public onChange: any = () => { };
  public onTouch: any = () => { };

  constructor() {}

  ngOnInit() {
  }

  public onChangeValue(event: InputEvent) {
    this.onChange(event.target['value']);
  }

  writeValue(obj: string): void {
    if (obj) {
      this.value = obj;
      this.onChange(this.value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
}
